module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.contacts), function(contact) {
    return _c('v-layout', {
      key: contact.contactId,
      attrs: {
        "ma-2": "",
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs7": "",
        "ma-4": ""
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.countries,
        "label": "Customers from these countries:",
        "item-text": "name",
        "item-value": "alpha2",
        "multiple": ""
      },
      model: {
        value: (_vm.dirtyCountriesSelected[contact.contactId]),
        callback: function($$v) {
          _vm.$set(_vm.dirtyCountriesSelected, contact.contactId, $$v)
        },
        expression: "dirtyCountriesSelected[contact.contactId]"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "ml-6": ""
      }
    }, [_c('i', [_c('small', {
      staticClass: "grey--text text--darken-2"
    }, [_vm._v("send returns to this contact:")])]), _vm._v(" "), _c('div', [_vm._v("\n        Contact ID: " + _vm._s(contact.contactId) + "\n      ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(contact.contactText1) + " " + _vm._s(contact.contactText2))])]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(contact.street) + "\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(contact.zipcode) + " " + _vm._s(contact.city) + "\n      ")]), _vm._v(" "), _c('br'), _c('br')])], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "ma-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('i', [_vm._v("The following countries are not mapped and therefore customers from these countries can not send a return to this customer:")]), _vm._v(" "), _c('i', [_vm._v("\n        " + _vm._s(_vm.notMappedCountries.map(function (c) { return c.name; }).join(", ")) + "\n      ")])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-58ce1850"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsCountryMappingForm.vue
// module id = 936
// module chunks = 1